import ModalRemove from "./ModalRemove";
import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import {
  obtenerCarrerasAdm,
  cambiarEstadoCarrera,
  ImportarCarreras,
  ActualizarCarrera,
} from "../../redux/carrerasSlice";
import {
  ObtenerTiposPeriodos,
  ObtenerTiposSesiones,
} from "../../redux/periodosSlice";
import {
  obtenerAreasCarreras,
  obtenerNivelCarreras,
} from "../../redux/genericosSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import OperationStatus from "../../config/OperationStatus";
import WindowDimension from "../../Hooks/WindowDimension";
import { useForm } from "react-hook-form";
import Modal from "./Modal";
import Required from "../../Components/Required";
import { OrderTable } from "../../Components/OrderTable";
import useSubmit from "../../Hooks/useSubmit";
import { getDaminOfertPage } from "../../Api/content";
import { useLocale } from "../../i18n/localeContext";
import { Skeleton } from "antd";
import { _translateValue } from "../translation-gestor/translateValue";

import { useValidation } from "../../Hooks/useValidation";

const SCREEN_NAME = "PantallaListaCarreras";
// columns are computed inside the component using useMemo

function ListaCarreras(props) {
  const { validation } = useValidation();
  const { locale } = useLocale();
  const [daminOfertPage, setDaminOfertPage] = useState(null);
  const [isLoadingContent, setIsLoadingContent] = useState(true);
  const [translatedCarreras, setTranslatedCarreras] = useState({});
  const [translatedTiposPeriodos, setTranslatedTiposPeriodos] = useState({});
  const [translatedSesiones, setTranslatedSesiones] = useState({});
  const [translatedAreas, setTranslatedAreas] = useState({});
  const [translatedNiveles, setTranslatedNiveles] = useState({});
  const [translatedModalidades, setTranslatedModalidades] = useState({});
  const [translatedEstados, setTranslatedEstados] = useState({});
  const [isTranslating, setIsTranslating] = useState(false);
  const [removeState, changeRemoveState] = useState(false);
  const [nivelId, setNivel] = useState(0);
  const [areaId, setArea] = useState(0);
  const [registerSelected = [], selectReg] = useState();
  const [showModal, setShowModal] = useState(false);
  const { width } = WindowDimension();
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();
  const dispatch = useDispatch();
  let busqueda = useRef();

  const { carrerasAdm } = useSelector((state) => state.carreras);
  const { tiposPeriodos, tiposSesiones } = useSelector(
    (state) => state.periodos
  );
  const { areasCarreras, nivelesCarreras } = useSelector(
    (state) => state.genericos
  );
  const { submitAction} = useSubmit();

  const columns = useMemo(() => {
    const table = daminOfertPage?.programOfert_table ?? [];
    return [
      { label: table[0]?.label || "Código", accessor: "codigo", sortable: true },
      { 
        label: table[1]?.label || "Carrera", 
        accessor: "carreraNombre", 
        sortable: true,
        render: (item) => (
          <td>{translatedCarreras[item.carreraNombre] || item.carreraNombre}</td>
        ),
      },
      { 
        label: table[2]?.label || "Tipo de periodo", 
        accessor: "tipoNombre", 
        sortable: true,
        render: (item) => (
          <td>{translatedTiposPeriodos[item.tipoNombre] || item.tipoNombre}</td>
        ),
      },
      { 
        label: table[3]?.label || "Sesión", 
        accessor: "sesionNombre", 
        sortable: true,
        render: (item) => (
          <td>{translatedSesiones[item.sesionNombre] || item.sesionNombre}</td>
        ),
      },
      { 
        label: table[4]?.label || "Área", 
        accessor: "area", 
        sortable: true,
        render: (item) => (
          <td>{translatedAreas[item.area] || item.area}</td>
        ),
      },
      { 
        label: table[5]?.label || "Nivel", 
        accessor: "nivel", 
        sortable: true,
        render: (item) => (
          <td>{translatedNiveles[item.nivel] || item.nivel}</td>
        ),
      },
      { 
        label: table[6]?.label || "Modalidad", 
        accessor: "modalidad", 
        sortable: true,
        render: (item) => (
          <td>{translatedModalidades[item.modalidad] || item.modalidad}</td>
        ),
      },
      { label: table[7]?.label || "Versión actual", accessor: "version", sortable: true },
      {
        label: table[8]?.label || "Estado",
        accessor: "estatus",
        sortable: true,
        render: (item) => (
          <td style={{ color: item.color }}>
            {translatedEstados[item.estatus] || item.estatus}
          </td>
        ),
      },
      { label: table[9]?.label || "Acción", accessor: "action", sortable: false },
    ];
  }, [daminOfertPage, translatedCarreras, translatedTiposPeriodos, translatedSesiones, translatedAreas, translatedNiveles, translatedModalidades, translatedEstados]);

  const cargarCarreras = useCallback(() => {
    let object = { areaId: 0, nivelId: 0, nombre: null };
    dispatch(obtenerCarrerasAdm(object));
    dispatch(ObtenerTiposSesiones());
    dispatch(ObtenerTiposPeriodos());
  }, [dispatch]);

  const cargarCarrerasPorArea = (e) => {
    setArea(e.target.value);
    let object = { areaId: e.target.value, nivelId: nivelId, nombre: null };
    dispatch(obtenerCarrerasAdm(object));
  };

  const cargarCarrerasPorNivel = (e) => {
    setNivel(e.target.value);
    let object = { areaId: areaId, nivelId: e.target.value, nombre: null };
    dispatch(obtenerCarrerasAdm(object));
  };

  const cargarCarrerasBusqueda = (e) => {
    let object = {
      areaId: areaId,
      nivelId: nivelId,
      nombre: busqueda.current.value,
    };
    dispatch(obtenerCarrerasAdm(object));
  };

  const activacion = async (estado, estatus) => {
    submitAction(
      cambiarEstadoCarrera,
      { id: registerSelected.id, estadoId: estado },
      () => {
        cargarCarreras();
        changeRemoveState(false);
      }
    );
  };

  useEffect(() => {
    cargarCarreras();
    dispatch(obtenerAreasCarreras());
    dispatch(obtenerNivelCarreras());
  }, [dispatch, cargarCarreras]);

  const importar = async () => {
    let { payload } = await dispatch(ImportarCarreras());
    if (payload.operationStatus === OperationStatus.SUCCESS) {
      cargarCarreras();
      toast.success(payload.message);
    } else {
      toast.error(payload.message);
    }
  };

  const showModalEdit = (item) => {
    reset(item);
    setShowModal(true);
  };
  const closeModalEdit = () => {
    setShowModal(false);
  };

  const onSubmit = async (data) => {
    let model = {
      id: data.id,
      tipoPeriodoId: parseInt(data.tipoPeriodoId),
      tipoSesion: parseInt(data.tipoSesion),
    };

    submitAction(ActualizarCarrera, model, () => {
      cargarCarreras();
      closeModalEdit();
    });
  };

  useEffect(() => {
    let cancel = false;
    setIsLoadingContent(true);
    getDaminOfertPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          setDaminOfertPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => { 
        if (!cancel) {
          setDaminOfertPage(null);
          setIsLoadingContent(false);
        }
      });
    return () => { cancel = true };
  }, [locale])

  // Efecto para traducir los campos cuando lleguen los datos o cambie el locale
  useEffect(() => {
    const translateData = async () => {
      // Verificar si hay datos para traducir
      const hasCarreras = carrerasAdm && Array.isArray(carrerasAdm) && carrerasAdm.length > 0;

      // Si no hay datos, no hacer nada
      if (!hasCarreras) {
        setIsTranslating(false);
        return;
      }

      // Iniciar traducción
      setIsTranslating(true);

      const carreraTranslations = {};
      const tipoPeriodoTranslations = {};
      const sesionTranslations = {};
      const areaTranslations = {};
      const nivelTranslations = {};
      const modalidadTranslations = {};
      const estadoTranslations = {};

      // Traducir los campos solicitados
      const translationPromises = carrerasAdm.map(async (item) => {
        if (item.carreraNombre) {
          const translated = await _translateValue(SCREEN_NAME, item.carreraNombre, locale);
          carreraTranslations[item.carreraNombre] = translated;
        }
        if (item.tipoNombre) {
          const translated = await _translateValue(SCREEN_NAME, item.tipoNombre, locale);
          tipoPeriodoTranslations[item.tipoNombre] = translated;
        }
        if (item.sesionNombre) {
          const translated = await _translateValue(SCREEN_NAME, item.sesionNombre, locale);
          sesionTranslations[item.sesionNombre] = translated;
        }
        if (item.area) {
          const translated = await _translateValue(SCREEN_NAME, item.area, locale);
          areaTranslations[item.area] = translated;
        }
        if (item.nivel) {
          const translated = await _translateValue(SCREEN_NAME, item.nivel, locale);
          nivelTranslations[item.nivel] = translated;
        }
        if (item.modalidad) {
          const translated = await _translateValue(SCREEN_NAME, item.modalidad, locale);
          modalidadTranslations[item.modalidad] = translated;
        }
        if (item.estatus) {
          const translated = await _translateValue(SCREEN_NAME, item.estatus, locale);
          estadoTranslations[item.estatus] = translated;
        }
      });
      await Promise.all(translationPromises);

      // Actualizar estados y finalizar traducción
      setTranslatedCarreras(carreraTranslations);
      setTranslatedTiposPeriodos(tipoPeriodoTranslations);
      setTranslatedSesiones(sesionTranslations);
      setTranslatedAreas(areaTranslations);
      setTranslatedNiveles(nivelTranslations);
      setTranslatedModalidades(modalidadTranslations);
      setTranslatedEstados(estadoTranslations);
      setIsTranslating(false);
    };

    translateData();
  }, [carrerasAdm, locale]);

  if (isLoadingContent || isTranslating) {
    return (
      <main className="main-admin">
        <div className="main-admin-bar">
          <Skeleton.Input style={{ width: 300, height: 30 }} active />
          <div className="header-admin-bar-items ml-auto">
            <Skeleton.Input style={{ width: 150, height: 40 }} active />
            <Skeleton.Input style={{ width: 150, height: 40 }} active />
            <Skeleton.Input style={{ width: 200, height: 40 }} active />
            <Skeleton.Button style={{ width: 40, height: 40 }} active />
          </div>
        </div>
        <div className="table-container">
          <Skeleton.Input style={{ width: '100%', height: 400, minWidth: '800px' }} active />
        </div>
      </main>
    );
  }

  return (
    <main className="main-admin">
      <div className="main-admin-bar">
        <h2>{daminOfertPage?.title || "Carreras a ofertar"}</h2>

        <div className="header-admin-bar-items ml-auto">
          <label hidden>área</label>
          <select onChange={cargarCarrerasPorArea}>
            <option value="0">{daminOfertPage?.select_optionA || "Todas las áreas"}</option>
            {areasCarreras.map((item, i) => {
              return (
                <option key={i} value={item.areaId}>
                  {item.areaNombre}
                </option>
              );
            })}
          </select>

          <label hidden>nivel</label>
          <select onChange={cargarCarrerasPorNivel}>
            <option value="0">{daminOfertPage?.select_optionB || "Todos los niveles"}</option>
            {nivelesCarreras.map((item, i) => {
              return (
                <option key={i} value={item.nivelId}>
                  {item.nivelAcademicoNombre}
                </option>
              );
            })}
          </select>

          <label hidden>Búsqueda</label>
          <input
            type="search"
            placeholder={daminOfertPage?.search_input || "Búsqueda"}
            onChange={cargarCarrerasBusqueda}
            ref={busqueda}
            className="form-control"
          />
          <button className="search-button" onClick={importar}>
            <i className="material-icons"></i>
          </button>
        </div>
      </div>

      <ModalRemove
        estado={removeState}
        closeModalHandled={changeRemoveState}
        title={
          registerSelected.estadoId === 4
            ? daminOfertPage?.subtitleTR || "Desactivar oferta de carrera"
            : daminOfertPage?.subtitleT || "Activar oferta de carrera"
        }
        message={
          registerSelected.estadoId === 4
            ? daminOfertPage?.questionA || "¿Desea desactivar la siguiente oferta?"
            : daminOfertPage?.question || "¿Desea activar la siguiente oferta?"
        }
        item={registerSelected.carreraNombre}
        icon={
          registerSelected.estadoId === 5 ? (
            <i className="material-icons info"></i>
          ) : null
        }
        color={registerSelected.estadoId === 5 ? "activate-item" : null}
        btnGroup={
          <>
            <button
              className="button-text text-red"
              onClick={() =>
                activacion(registerSelected.estadoId === 4 ? 5 : 4)
              }
            >
              {daminOfertPage?.confirm_button || "Confirmar"}
            </button>
            <button
              className="button-text text-grey"
              onClick={() => {
                changeRemoveState(false);
              }}
            >
              {daminOfertPage?.cancel_button || "Cancelar"}
            </button>
          </>
        }
      />

      <div className="table-container">
        {carrerasAdm.length > 0 ? (
          <>
            <OrderTable
              {...{ columns }}
              data={carrerasAdm}
              clase="table-adm"
              renderActionItems={(item) => {
                return (
                  <td key={Math.random()}>
                    <button
                      className="modBtn text-primary "
                      onClick={() => {
                        showModalEdit(item);
                      }}
                    >
                      <i className="material-icons"></i>
                    </button>

                    {item.estadoId === 4 ? (
                      <button   className="modBtn text-primary ">
                        <i
                          className="material-icons statusRed"
                          onClick={() => {
                            selectReg(item);
                            changeRemoveState(true);
                          }}
                        >
                          
                        </i>
                      </button>
                    ) : (
                      <button   className="modBtn text-primary ">
                        <i
                          className="material-icons statusGreen"
                          onClick={() => {
                            selectReg(item);
                            changeRemoveState(true);
                          }}
                        >
                          
                        </i>
                      </button>
                    )}
                  </td>
                );
              }}
            />
          </>
        ) : (
          <div className="no-results-container">
            <img src={props.img} alt="Imagen sin resultados" />
            <h1>{props.noResultMessage}</h1>
          </div>
        )}
      </div>

      <Modal
        estado={showModal}
        cambiarEstado={closeModalEdit}
        titulo={daminOfertPage?.subtitleO || "Editar"}
        clase={`${width < 576 ? "full-width" : "small"}`}
        buttonGroup={
          <>
            <button
              type="submit"
              className="button-text"
              onClick={handleSubmit(onSubmit)}
            >
              {daminOfertPage?.save_button || "Guardar"}
            </button>
          </>
        }
      >
        <form>
          <div className="form-group">
            <label>{daminOfertPage?.termtype || "Tipo de periodo"}</label>
            <Required />
            <select
              className="form-control"
              {...register("tipoPeriodoId", { required: validation?.required_field || "Campo requerido" })}
            >
              <option value={undefined}>{daminOfertPage?.select_option || "Seleccione"}</option>
              {tiposPeriodos?.map((a, i) => {
                return (
                  <option key={i} value={a.periodoTipoId}>
                    {a.periodoTipoNombre}
                  </option>
                );
              })}
            </select>
            {errors.tipoPeriodoId && (
              <p className="error">{errors.tipoPeriodoId.message}</p>
            )}
          </div>
          <div className="form-group">
            <label>{daminOfertPage?.sessiontype || "Tipo de sesión"}</label>
            <Required />
            <select
              className="form-control"
              {...register("tipoSesion", { required: validation?.required_field || "Campo requerido" })}
              name="tipoSesion"
            >
              <option value={undefined}>{daminOfertPage?.select_option || "Seleccione"}</option>
              {tiposSesiones?.map((a, i) => {
                return (
                  <option key={i} value={a.sesionId}>
                    {a.sesionNombre}
                  </option>
                );
              })}
            </select>
            {errors.tipoSesion && (
              <p className="error">{errors.tipoSesion.message}</p>
            )}
          </div>
        </form>
      </Modal>
    </main>
  );
}

export default ListaCarreras;
